import React, { useState } from 'react';
import './../components/faqsection.css'
import { FaPlus ,FaMinus} from "react-icons/fa";
import './../style/common.css'
const faqs = [
  {
    question: 'What type of cuisine does Mandurah Cafe serve?',
    answer:
      'Mandurah Cafe serves a diverse range of cuisines including Aussie breakfast, Indian cuisine, Indo-Chinese, and Indian street food, catering to all taste preferences.'
  },
  {
    question: 'Where is Mandurah Cafe located?',
    answer:
      'Mandurah Cafe is conveniently located at 31 Sholl St, Mandurah WA 6210, right in the heart of the Mandurah city center.'
  },
  {
    question: 'Do you offer vegan, gluten-free, or no onion garlic food options?',
    answer:
      'Yes, Mandurah Cafe offers special dietary options such as Vegan (VG), Gluten-Free (GF), and No Onion Garlic (NOG) meals across selected menu items.'
  },
  {
    question: 'What are Mandurah Cafe’s opening hours?',
    answer:
      'Mandurah Cafe is open daily with early morning Aussie breakfasts from 6:00 AM. For full operating hours, please check the Opening Hours section on our website.'
  },
  {
    question: 'Can I order food online from Mandurah Cafe?',
    answer:
      'Yes, Mandurah Cafe offers online ordering for both takeaway and dine-in. You can easily place your order directly through our website.'
  },
  {
    question: 'Does Mandurah Cafe offer catering services?',
    answer:
      'Yes, we provide catering services for parties, events, and office functions. Contact us via our catering menu or call for more details.'
  },
  {
    question: 'What is the best breakfast option at Mandurah Cafe?',
    answer:
      'Our Aussie Breakfast is a local favorite, featuring a hearty mix of eggs, toast, bacon, and more — freshly served every morning in Mandurah.'
  },
  {
    question: 'Do you have Indian street food options?',
    answer:
      'Yes, Mandurah Cafe serves authentic Indian street food like samosas, pav bhaji, chaat, and more — full of bold flavors and made fresh to order.'
  },
  {
    question: 'Is table reservation available at Mandurah Cafe?',
    answer:
      'Yes, table reservations are available to guarantee your seat and ensure a smooth dine-in experience, especially during peak hours.'
  },
  {
    question: 'Why is Mandurah Cafe considered one of the best cafes in Mandurah?',
    answer:
      'Mandurah Cafe is loved for its diverse menu, central location, Aussie breakfast, Indo-Chinese fusion, and Indian cuisine, with options for every dietary need.'
  }
];


const FaqSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="faq-section">
      {/* <p className="subheading">LOREM IPSUM SUB HEADING</p> */}
      <h2>FAQs</h2>

      <div className="faq-grid">
        {faqs.map((faq, index) => (
          <div className="faq-item" key={index}>
            <div className="faq-question" onClick={() => toggle(index)}>
              <span className="icon">{activeIndex === index ? <FaMinus/> : <FaPlus />}</span>
              <h3>{faq.question}</h3>
            </div>
            {activeIndex === index && faq.answer && (
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FaqSection;
